import { Expose } from 'class-transformer';
import { ContactResponseDto } from './contact-response.dto';

export class ContactWithRoleResponseDto extends ContactResponseDto {
    /**
     * Entity contact ID from entity_contacts table
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    entityContactId?: string;

    /**
     * Role description from entity_contacts table
     * @example 'Quality Manager'
     */
    @Expose()
    roleDescription?: string;

    /**
     * Context from entity_contacts table
     * @example 'Main Contact Customer Update'
     */
    @Expose()
    context?: string;
}
